import React, { useEffect, useState } from "react";
import { getChainAbiAddressUrl } from "utils/helper";

const useChainAbiAddressAndUrl = (networkSelected) => {


    
  // const [tvkContAddress, setTvkContAddress] = useState(null);
  // const [stakeContAddress, setStakeContAddress] = useState(null);
  // const [tvkContAbi, setTvkContAbi] = useState(null);
  // const [stakeContAbi, setStakeContAbi] = useState(null);
  // const [transactionUrlVal, setTransactionUrlVal] = useState(null);

  const {
    tvkContractAddress,
    tvkStakeContractAddress,
    tvkAbi,
    stakeAbi,
    transactionUrl,
  } = getChainAbiAddressUrl(networkSelected);

  // useEffect(() => {
  //   if (networkSelected) {
  //        const {
  //          tvkContractAddress,
  //          tvkStakeContractAddress,
  //          tvkAbi,
  //          stakeAbi,
  //          transactionUrl,
  //        } = getChainAbiAddressUrl(networkSelected);
  //     setTvkContAddress(tvkContractAddress);
  //     setStakeContAddress(tvkStakeContractAddress);
  //     setTvkContAbi(tvkAbi);
  //     setStakeContAbi(stakeAbi);
  //     setTransactionUrlVal(transactionUrl);
  //   }
  // }, [networkSelected]);
  return {
    tvkContractAddress,
    tvkStakeContractAddress,
    tvkAbi,
    stakeAbi,
    transactionUrl,
  };
};

export default useChainAbiAddressAndUrl;
